import classNames from "classnames";
import { useEffect, useState } from "react";
import "./GoogleMap.css";

function createMarker(title: string, position: google.maps.LatLngLiteral) {
    return new google.maps.Marker({
        position,
        title,
    });
}

function createMap(mapElementId: string, centerPosition: google.maps.LatLngLiteral) {
    return new google.maps.Map(document.getElementById(mapElementId)!, {
        zoom: 0, // Zoom level is decided later based on marker
        center: centerPosition,
    });
}

type Props = {
    mapId: string;
    markerTitle: string;
    markerPosition: google.maps.LatLngLiteral;
    viewport: google.maps.LatLngBounds;
    className?: string;
};

function GoogleMap(props: Props) {
    const { className, mapId, markerPosition, markerTitle, viewport } = props;
    const mapElementId = `lmt-google-map__${mapId}`;
    const [map, setMap] = useState<google.maps.Map | null>(null);

    useEffect(() => {
        if (window.google) {
            const mapElement = createMap(mapElementId, markerPosition);
            setMap(mapElement);
        }
    }, [mapElementId, markerPosition]);

    useEffect(() => {
        if (map) {
            const marker = createMarker(markerTitle, markerPosition);

            marker.setMap(map);
            map.fitBounds(viewport);
            map.setOptions({ gestureHandling: "cooperative" });
        }
    }, [map, markerPosition, markerTitle, viewport]);

    return (
        <div id={mapElementId} className={classNames("lmt-google-map", className)} />
    );
}

export default GoogleMap;
